/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { MandatoryDeductionDto } from './mandatoryDeductionDto.schema';

export const IReadOnlyListOfMandatoryDeductionDto = zod.array(zod.lazy(() => MandatoryDeductionDto));

export type IReadOnlyListOfMandatoryDeductionDto = zod.input<typeof IReadOnlyListOfMandatoryDeductionDto>;
export type IReadOnlyListOfMandatoryDeductionDtoOutput = zod.output<typeof IReadOnlyListOfMandatoryDeductionDto>;
